module.exports = __webpack_public_path__ + "static/media/redBg.c336f289.jpg";